export enum OrganizationConfigurationEnum {
  CustomerInterestCalculation = 2,
  BuilderInterestCalculation = 3,
  CallQueueLength = 4,
  LeadMasking = 5,
  CustomerEmail = 6,
  DisableStickyAgent = 7,
  CustomerAppWebsite = 8,
  DownloadBrochureLink = 9,
  LateCharges = 10,
  CustomSalesTeamAssignment = 11,
  PropertyShare = 12,
  CanTDSDisplay = 13,
  TDSIsAPartOfPayment = 14,
  PricingRoundOff = 15,
  FeedbackUpdate = 16,
  CanAgeOfLeadDisplay= 17
}
